package br.com.texeratx.boardgametimeapp.ui.screens.games

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEvent
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import cafe.adriel.voyager.core.screen.Screen
import org.koin.compose.koinInject

class GameScreen : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<GamesViewModel>()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(Unit) {
            viewModel.loadGames()
        }

        LaunchedEffect(Unit) {
            AppUiEventBus.events.collect { event ->
                if (event is AppUiEvent.GameDeleted) {
                    viewModel.loadGames()
                }
            }
        }

        GamesUI(
            state = state,
            onSortChange = { viewModel.changeSort(it) },
            onDismissError = { viewModel.state.value = state.copy(error = null) },
            onSearch = viewModel::onSearch,
            onApplyFilters = viewModel::updateFilters,
        )
    }
}
